import { HeroEventProps } from '@sbercloud/uikit-product-site-hero';
import { useRouter } from 'next/navigation';

import { ClickAnalyticsType } from '../../../types';
import { EventOrWebinarType } from '../../../types/backendContent';

export const useBreadcrumbs = (
  { id, title }: EventOrWebinarType,
  clickAnalytics: (props: ClickAnalyticsType) => void,
): HeroEventProps['breadcrumbs'] => {
  const router = useRouter();

  const handleClick = ({ href, label }: { href: string; label: string }) => {
    clickAnalytics({
      action: href,
      clickZone: 'body',
      clickElement: 'breadcrumb',
      clickContent: label,
      uniqueId: `breadcrumb-link-${label}`,
      transitionType: 'inside-link',
    });
  };

  return [
    {
      id: 'main',
      label: 'Главная',
      href: '/',
    },
    {
      id: 'events',
      label: 'Мероприятия',
      href: '/events',
    },
    {
      id,
      label: title,
    },
  ].map((item) => ({
    ...item,
    onClick: item.href
      ? (e) => {
          e.preventDefault();
          handleClick(item);
          router.push(item.href);
        }
      : undefined,
    'data-test-id': item.href ? 'section_link' : 'breadcrumb',
  }));
};
